import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from '@/types/store';
import authModule from './auth';
import appModule from './app';

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
  modules: {
    auth: authModule,
    app: appModule
  },
  strict: process.env.NODE_ENV !== 'production'
};

const store = new Vuex.Store<RootState>(storeOptions);

export default store;

export { GET_EXPORT_BY_ID, EXPORT_FILES, ExportFile } from './app';

export { LOGIN, HANDLE_AUTHENTICATION, IS_LOGGED_IN, LOGOUT } from './auth';
